import React from 'react';
import { Button } from '@/components/ui/Button';
import { Send, Save, ArrowLeft } from 'lucide-react';

interface SubmissionActionsProps {
  onSaveDraft: () => void;
  onSubmitReview: () => void;
  onCancel: () => void;
  isSavingDraft: boolean;
  isSubmitting: boolean;
  isDirty?: boolean;
  lastSavedAt?: string | null;
}

export const SubmissionActions: React.FC<SubmissionActionsProps> = ({
  onSaveDraft,
  onSubmitReview,
  onCancel,
  isSavingDraft,
  isSubmitting,
  isDirty = false,
  lastSavedAt = null,
}) => {
  return (
    <div className="sticky bottom-4 z-20 p-4 rounded-xl border border-border bg-background/95 backdrop-blur-md shadow-xl flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <Button variant="outline" size="sm" onClick={onCancel} disabled={isSavingDraft || isSubmitting}>
          <ArrowLeft className="h-3.5 w-3.5 mr-1.5" /> Cancel
        </Button>
        <div className="text-xs text-foreground-secondary hidden sm:flex items-center gap-2">
          {isDirty ? (
            <span className="text-amber-500 font-medium">Unsaved changes in form</span>
          ) : lastSavedAt ? (
            <span className="text-emerald-500 font-mono text-[11px]">Draft saved {lastSavedAt}</span>
          ) : (
            <span>Ready for validation</span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          size="sm"
          isLoading={isSavingDraft}
          onClick={onSaveDraft}
          disabled={isSubmitting}
        >
          <Save className="h-3.5 w-3.5 mr-1.5" /> Save Draft
        </Button>

        <Button size="sm" isLoading={isSubmitting} onClick={onSubmitReview} disabled={isSavingDraft}>
          <Send className="h-3.5 w-3.5 mr-1.5" /> Submit Requisition
        </Button>
      </div>
    </div>
  );
};
